<template lang="pug">
  div.test
    p Hello!
    pre {{order}}
</template>
<script>
export default {
  props:['product','active','activeId','order','test'],
  created() {
    console.log(this.order)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/test.vue